export function getExpirationStatus(dateStr) {
  if (!dateStr) return { key: "sem_vencimento", label: "Sem vencimento", classes: "bg-slate-100 text-slate-600 border-slate-200" };
  const exp = new Date(dateStr);
  if (isNaN(exp.getTime())) return { key: "sem_vencimento", label: "Sem vencimento", classes: "bg-slate-100 text-slate-600 border-slate-200" };
  const today = new Date();
  today.setHours(0,0,0,0);
  const diff = Math.floor((exp - today) / (1000 * 60 * 60 * 24));
  if (diff < 0) return { key: "vencido", label: "Vencido", classes: "bg-red-50 text-red-700 border-red-200" };
  if (diff <= 30) return { key: "vence_em_breve", label: "Vence em breve", classes: "bg-amber-50 text-amber-800 border-amber-200" };
  return { key: "valido", label: "Válido", classes: "bg-emerald-50 text-emerald-700 border-emerald-200" };
}

export const CATEGORY_LABELS = {
  contrato: "Contrato",
  nota_fiscal: "Nota Fiscal",
  exame_medico: "Exame Médico",
  curso: "Curso",
  recibo: "Recibo",
  advertencia: "Advertência",
  ferias: "Férias",
  rescisao: "Rescisão",
  pagamento: "Pagamento",
  cartao_ponto: "Cartão de Ponto",
  extra: "Extras",
  holerite: "Holerite",
  cnh: "CNH",
  ctps: "Carteira de Trabalho",
  cpf_doc: "CPF",
  cartao_vacina: "Cartão de Vacina",
  rg_doc: "RG",
  atestado: "Atestado Médico",
};

// Categories that always require an expiration date
export const EXPIRATION_REQUIRED = new Set(["exame_medico", "curso", "cnh"]);

// Category groups for sub-navigation
export const CATEGORY_GROUPS = [
  {
    label: "Documentos Pessoais",
    items: ["cnh", "ctps", "cpf_doc", "rg_doc", "cartao_vacina"],
  },
  {
    label: "Contratuais",
    items: ["contrato", "rescisao", "advertencia", "ferias"],
  },
  {
    label: "Financeiro",
    items: ["nota_fiscal", "recibo", "pagamento", "holerite"],
  },
  {
    label: "Segurança do Trabalho",
    items: ["exame_medico", "curso", "atestado"],
  },
  {
    label: "Operacional",
    items: ["cartao_ponto", "extra"],
  },
];

export function formatDate(d) {
  if (!d) return "—";
  try {
    const [y, m, day] = d.split("T")[0].split("-");
    return `${day}/${m}/${y}`;
  } catch { return d; }
}

export function initials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] || "") + (parts[parts.length-1]?.[0] || "")).toUpperCase();
}
